import { lazy, Suspense } from 'react'
import { createRootRoute, createRoute, createRouter, Navigate, Outlet } from '@tanstack/react-router'

const HomePage = lazy(() => import('./pages/home-page'))
const NewsPage = lazy(() => import('./pages/news-page'))
const TrendsPage = lazy(() => import('./pages/trends-page'))

function LazyPage({ children }: { children: React.ReactNode }) {
	return (
		<Suspense fallback={
			<div className="min-h-screen bg-background flex items-center justify-center">
				<div className="inline-block h-6 w-6 animate-spin rounded-full border-2 border-primary border-t-transparent" />
			</div>
		}>
			{children}
		</Suspense>
	)
}

const rootRoute = createRootRoute({
	component: () => <Outlet />,
	notFoundComponent: () => <Navigate to="/" replace />,
})

const indexRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: '/',
	component: () => (
		<LazyPage>
			<HomePage />
		</LazyPage>
	),
})

const newsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: '/news',
	component: () => (
		<LazyPage>
			<NewsPage />
		</LazyPage>
	),
})

const trendsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: '/trends',
	component: () => (
		<LazyPage>
			<TrendsPage />
		</LazyPage>
	),
})

const routeTree = rootRoute.addChildren([indexRoute, newsRoute, trendsRoute])

export const router = createRouter({
	routeTree,
	defaultPreload: 'intent',
	trailingSlash: 'always',
})

declare module '@tanstack/react-router' {
	interface Register {
		router: typeof router
	}
}
